import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PhoneCall } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useAlertaFaixa } from './alertas/AlertasContexto';

// Faixa de RETOMAR ORCAMENTOS — a fila do vendedor ([DA-669]).
//
// E' o mecanismo que responde "como ele sabe que tem trabalho?" sem ninguem cobrar: mesma receita
// da faixa do estoquista. O Ruan foi explicito sobre o motivo — *"ficar cobrando nao da resultado e
// gera desgaste; o melhor seria fazer igual ao Joao, criar as pendencias, de forma que ele chegue
// pra trabalhar e ja saiba o que tem que fazer"*.
//
// ⚠️ PRIMEIRA faixa da casa que inclui 'vendedor'. Todas as outras param em admin/gerente/estoquista,
// porque alarme sem porta pra resolver vira ruido — aqui a porta existe e e' dela: o resumo ja vem
// filtrado pelo servidor, entao a vendedora ve a contagem DELA e nunca a das outras.
//
// So o balde "pro cliente" acende. Separacao e sem-contato aparecem na tela como abas, mas nao sao
// trabalho a fazer: nao ha numero de cliente pra ligar, e alarme que ninguem consegue apagar vira
// papel de parede ([DA-360]).
// ⚠️ A faixa conta `cliente_pendente`, NAO `cliente`. Desde 04/09/2026 o pedido adiado FICA na
// lista, com a situacao preenchida na caixa ([DA-672]) — entao `cliente` passou a incluir o que ja
// foi tratado. Contar ele aqui faria a vendedora agendar os 12 do dia e o aviso continuar dizendo
// 12: alarme que nao apaga quando a pessoa trabalha vira papel de parede ([DA-360]). A lista
// responde "o que esta na fila"; a faixa responde "o que falta fazer AGORA".
interface Resumo { cliente: number; separacao: number; sem_contato: number; cliente_pendente: number; dias: number }

const POLLING_MS = 5 * 60 * 1000;

export function AlertaRetomarOrcamentosBanner() {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [resumo, setResumo] = useState<Resumo | null>(null);

  const podeVer = usuario && ['admin', 'gerente', 'vendedor'].includes(usuario.perfil);

  useEffect(() => {
    if (!podeVer) return;
    let cancelado = false;
    async function tick() {
      try {
        const r = await api.get<Resumo>('/api/fila-retomada/resumo');
        if (!cancelado) setResumo(r);
      } catch { /* silencioso: a faixa some, o resto da tela nao cai por causa dela */ }
    }
    void tick();
    const id = setInterval(tick, POLLING_MS);
    return () => { cancelado = true; clearInterval(id); };
  }, [podeVer]);

  const ativo = !!(podeVer && resumo && resumo.cliente_pendente > 0);
  const recolhido = useAlertaFaixa(
    'retomar-orcamentos',
    ativo ? { rotulo: 'Retomar', bg: '#eab308', borda: '#a16207', qtd: resumo!.cliente_pendente } : null,
  );

  if (!ativo || recolhido || !resumo) return null;

  const n = resumo.cliente_pendente;
  return (
    <div
      style={{
        background: '#eab308',
        borderLeft: '4px solid #a16207',
        color: '#000',
        padding: '8px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 13,
        cursor: 'pointer',
      }}
      onClick={() => navigate('/orcamentos/fila')}
    >
      <PhoneCall size={16} />
      <span style={{ fontWeight: 600 }}>Retomar:</span>
      <span>
        {n} {n === 1 ? 'orcamento aberto' : 'orcamentos abertos'} dos ultimos {resumo.dias} dias
        {' '}esperando retorno — depois disso o cliente quase sempre ja comprou
      </span>
      <span style={{ marginLeft: 'auto', textDecoration: 'underline' }}>Ver fila</span>
    </div>
  );
}
